import {makeStyles} from "@mui/styles";

export const Styles: any = makeStyles((theme) => ({
    root: {
        width: '100%'
    },
}));
